import axios from 'axios';
import config from '../apiConfig';

/**
 * Returns a promise for list of settings that clients use to customize the kiosk.
 * This includes: logo and topics for kiosk topic pages.
 * @param {axios cancellation token} cancelToken - use this to cancel an existing request.
 * Generate this using the helper function getCancellationToken
 */
const getBrandInfo = cancelToken => {
	const instance = axios.create(config);

	return instance.get('BrandInfo', {
		cancelToken,
	});
};

// eslint-disable-next-line import/prefer-default-export
export { getBrandInfo };
